import React, { useEffect } from 'react';
import {
  Box,
  Button,
  Text,
  Accordion,
  Grid,
  Spacer,
} from '@flexisaf/flexibull2';
import CanView, { Permissions } from 'components/CanView';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton';
import EmptyCourse from 'assets/images/empty_course.svg';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import { loadingEmails, selectLoadedEmails } from 'redux/applicants/selector';
import { fetchCandidateEmails } from 'redux/applicants/actions';
import { selectInstitution } from 'redux/configurations/selectors';
import { FALL_BACK_TZ } from 'utils/constants';
import { calculateDateOffset } from 'utils/helpers';

const moment = require('moment-timezone');

const EmailTab = ({ applicant, sendEmail }) => {
  const dispatch = useDispatch();
  const institution = useSelector(selectInstitution);
  const emails = useSelector(selectLoadedEmails);
  const loading = useSelector(loadingEmails);

  useEffect(() => {
    if (applicant?.id) {
      dispatch(fetchCandidateEmails(applicant?.id));
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [applicant]);

  if (loading) {
    return (
      <Box width="100%" vAlign>
        <Box width="100%" margin="30px 0" align="center">
          <SkeletonTheme color="#d0d5d933" highlightColor="#c2cad133">
            <Skeleton count={5} height={50} />
          </SkeletonTheme>
        </Box>
      </Box>
    );
  }

  return (
    <Box pad="20px 26px 20px 0" className="email-wrapper">
      <CanView can={[Permissions.CREATE_EMAIL]}>
        <Box align="right">
          <Button
            pale
            spaceRight="0"
            iconRight={<i style={{ fontSize: '13px' }} className="saf-mail" />}
            spaceLeft="auto"
            onClick={() => sendEmail()}
          >
            Send Email
          </Button>
        </Box>
      </CanView>

      {emails.length === 0 ? (
        <Box vAlign height="70vh">
          <Box width="200px" margin="0 auto" align="center">
            <img src={EmptyCourse} alt="Empty Course" />
            <Spacer />
            <Text>No Emails found</Text>
            <Spacer />
          </Box>
        </Box>
      ) : (
        emails.map((email) => (
          <Accordion mode="plain" gap="10px" key={email.id}>
            <div label={email?.subject}>
              <Box margin="0 -15px -10px">
                <Box
                  background="#9e9eb70f"
                  pad="10px 20px"
                  margin="-25px 0 0 0"
                >
                  <Grid default="1fr max-content" gap="30px">
                    <Box>
                      <Box margin="0 auto 0 0">
                        <Text bold>From:</Text>{' '}
                        <Text>
                          {email?.senderUsername} ({email?.from})
                        </Text>
                      </Box>
                      <Box margin="5px auto 0 0">
                        <Text bold>To:</Text>{' '}
                        <Text>
                          {applicant?.firstName} {applicant?.middleName}{' '}
                          {applicant?.lastName} ({email?.to})
                        </Text>
                      </Box>
                    </Box>
                    <Box align="right" margin="0 0 0 auto">
                      <Text>
                        {moment(
                          calculateDateOffset(
                            email?.createdAt,
                            institution?.timeZone
                          )
                        )
                          .tz(institution?.timeZone || FALL_BACK_TZ)
                          .format('MMMM Do YYYY')}{' '}
                        -
                      </Text>{' '}
                      <Text>
                        {moment(
                          calculateDateOffset(
                            email?.createdAt,
                            institution?.timeZone
                          )
                        )
                          .tz(institution?.timeZone || FALL_BACK_TZ)
                          .format('h:mm a')}
                      </Text>
                    </Box>
                  </Grid>
                </Box>
                <Box pad="15px 20px 5px">
                  <Text
                    block
                    size="14px"
                    dangerouslySetInnerHTML={{ __html: email?.message }}
                  />
                </Box>
              </Box>
            </div>
          </Accordion>
        ))
      )}
    </Box>
  );
};

export default EmailTab;

EmailTab.propTypes = {
  applicant: PropTypes.object,
  sendEmail: PropTypes.func,
};
